export const INVOICE_BRAND = {
  companyName: "Alijay Empire",
  tradingName: "Premium Abnormal Load Transport & Logistics",
  registration: "Reg No: 2024/ALJ/0091",
  vatNumber: "9341292226",
  taxCode: "9341292226",
  contactEmail: "operations@alijayempire.co.za",
  contactPhone: "+27 83 602 51384",
  address: "774 Clare Road Clare Estate Durban",
  addressLines: [
    "774 Clare Road Clare Estate Durban",
    "Durban Kwazulu Natal",
    "South Africa"
  ],
  validityDays: 7,
  palette: {
    primary: "#004a76",
    primaryDark: "#003a5d",
    accent: "#ed1c24",
    accentDark: "#c1131a",
    surface: "#f8fafc",
    text: "#0f172a"
  },
  terms: [
    "Quotation valid for 7 calendar days from issue date.",
    "Pricing excludes exceptional delays outside planned route windows.",
    "Permit and escort approvals remain subject to authority confirmation.",
    "Any scope changes may require re-assessment and revised pricing."
  ],
  transportRegulations: [
    "Operations comply with South African National Road Traffic Act abnormal load provisions.",
    "Movement windows and curfews must follow permit authority restrictions.",
    "Bridge, overhead and corridor clearances must be verified before dispatch.",
    "Escort and police support requirements remain mandatory where classification demands."
  ],
  companyTerms: [
    "Quoted pricing is based on declared load dimensions and route profile.",
    "Client-approved scope changes trigger revised commercials before movement.",
    "Delays caused by weather, authority holds, or road closures may incur standby charges.",
    "Loading and offloading site readiness remains client responsibility unless contracted."
  ]
};
